import React from "react";
import Modal from "..";
import * as S from "./transferDetailModal.style";
import { Button } from "../../../atoms/Buttons";

type TransferDetailModalProps = {
  onClose: () => void;
  modalMessage: string;
};

const TransferDetailModal = ({
  onClose,
  modalMessage,
}: TransferDetailModalProps) => {
  return (
    <Modal title="운송매칭 실패" titlePosition="center" size="md">
      <S.TransferDetailModalLayout>
        <p>{modalMessage}</p>
        <Button
          type="button"
          size="full"
          color="primary"
          label="확인"
          onClick={onClose}
        />
      </S.TransferDetailModalLayout>
    </Modal>
  );
};

export default TransferDetailModal;
